export default "__VITE_ASSET__c240f741__"